import { z } from "zod";

export const TOP_SHOP_PARISHES = ["Westmoreland", "Hanover", "St. Elizabeth", "St. James", "Trelawny"] as const;

export const whatsappNumberSchema = z.string().trim()
  .min(1, "WhatsApp number is required")
  .max(40, "WhatsApp number must be 40 characters or fewer")
  .regex(/^\+?[0-9 -]+$/, "Enter a valid phone number using digits, spaces, dashes and an optional leading +")
  .refine((value) => value.replace(/\D/g, "").length >= 7, "WhatsApp number must contain at least 7 digits");

export function applicationParishSchema(savedParish?: string) {
  return z.string({ required_error: "Parish is required" }).refine(
    (parish) => TOP_SHOP_PARISHES.some((allowed) => allowed === parish) || Boolean(savedParish && parish === savedParish),
    "Please select one of the five eligible parishes",
  );
}